import cn from 'classnames'
import { useSnapshot } from 'valtio'
import { type ReactElement } from 'react'
import { globalMerchantsProxy } from '../../../proxies/globalMerchantsProxy'
import { proxyGlobalAuth } from '../../../proxies/proxyGlobalAuth'
import { executeUserHotSwap } from './executeUserHotSwap'

const COMMON_MENU_ITEM_CLASSES = 'text-gray-700 flex justify-between w-full px-4 py-2 text-sm leading-5 ' +
  'text-left cursor-pointer active:text-gray-600 hover:bg-wpy-light-gray-400'

export function MerchantSelector (): ReactElement | null {
  const { merchants, selectedMerchant } = useSnapshot(globalMerchantsProxy)
  const dropDownMerchants = merchants.filter(m => m.ppMerchantId !== globalMerchantsProxy.selectedMerchant?.ppMerchantId)
  const { siteTheme: { topNavBarMerchantSelector } } = useSnapshot(proxyGlobalAuth)
  if (selectedMerchant == null) { return null }
  return (
    <>
      <div className="relative inline-block text-left dropdown mr-4">
        <button
          className={
            cn(
              topNavBarMerchantSelector.classes,
              'px-4 py-2 transition duration-150 ease-in-out rounded border h-8 flex justify-center items-center font-semibold',
              dropDownMerchants.length > 1 ? 'hover:text-gray-700 cursor-pointer' : 'cursor-auto'
            )
          }
          type="button"
        >
          {selectedMerchant.merchantName}
          &nbsp;&nbsp;
          {dropDownMerchants.length > 0 && '▾'}
        </button>
        {dropDownMerchants.length > 0 && (
          <div
            className="opacity-0 invisible dropdown-menu transition-all duration-300 transform origin-top-right -translate-y-2 scale-95"
          >
            <div
              className="absolute right-0 w-56 origin-top-right bg-white border border-gray-200 divide-y divide-gray-100 rounded-md shadow-lg outline-none"
              role="menu"
            >
              <div className="py-1">
                {dropDownMerchants.map(m => (
                  <a
                    onClick={() => { void executeUserHotSwap({ ppMerchantId: m.ppMerchantId }) }}
                    key={m.ppMerchantId}
                    className={COMMON_MENU_ITEM_CLASSES}
                    role="menuitem"
                  >
                    {m.merchantName}
                  </a>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>

      <style jsx>{`
        .dropdown:hover .dropdown-menu {
          opacity:1;
          transform: translate(0) scale(1);
          visibility: visible;
        }
      `}
      </style>
    </>
  )
}
